import { Cookies } from '@/shared/helpers/Cookies'
import { ChatsStore } from '../ChatsStore'
import { chatsGetAll } from './chatsGetAll'
import { Chat } from '@/shared/interfaces/Chat'
let isRefreshing = false

export async function chatsRefresh(): Promise<Chat[]> {
  const { chatsStore } = ChatsStore.get()
  if (isRefreshing) {
    return chatsStore.state.chats
  }
  isRefreshing = true
  try {
    if (!Cookies.get('userId')) {
      await chatsStore.dispatch(async (state) => {
        state.userId = 0
        state.chats = []
      })
    } else {
      await chatsStore.dispatch(async (state) => {
        state.userId = +Cookies.get('userId')
      })

      const chats = await chatsGetAll()

      await chatsStore.dispatch(async (state) => {
        state.chats = chats.filter(item => item)
      })
    }

    await chatsStore.dispatch(async (state) => {
      state.isLoading = false
    })

    return chatsStore.state.chats
  } finally {
    isRefreshing = false
  }
}
